import { useEffect, useState } from "react";
import { api } from "@/app/api";
import { Card, StatusBadge } from "@/app/ui";
import { Wallet, GraduationCap, Sparkles, ChevronRight } from "lucide-react";

const TABS = ["All", "Eligible", "Tracking"];

export default function Funding() {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("All");
  useEffect(() => { api.get("/individual/funding").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <p className="text-slatey">Loading funding…</p>;
  const s = data.stats;
  const list = data.funding.filter((f) =>
    tab === "All" ? true : tab === "Eligible" ? f.status === "eligible" : ["applied", "awarded"].includes(f.status));

  const money = (n) => `£${n.toLocaleString("en-GB")}`;

  return (
    <div data-testid="funding-page">
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-ink">Funding centre</h1>
      <p className="mt-2 text-slatey">Discover and track loans, scholarships, bursaries, employer funding and apprenticeship routes.</p>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Card><p className="text-sm text-slatey">Eligible</p><p className="mt-2 font-display text-3xl font-black text-ink">{s.eligible}</p><p className="text-sm text-slatey">You may qualify</p></Card>
        <Card><p className="text-sm text-slatey">Applied</p><p className="mt-2 font-display text-3xl font-black text-ink">{s.applied}</p><p className="text-sm text-slatey">In progress</p></Card>
        <Card><p className="text-sm text-slatey">Awarded</p><p className="mt-2 font-display text-3xl font-black text-ink">{s.awarded}</p><p className="text-sm text-slatey">Secured</p></Card>
        <Card><p className="text-sm text-slatey">Potential</p><p className="mt-2 font-display text-3xl font-black text-ink">{money(s.potential)}</p><p className="text-sm text-slatey">Combined estimate</p></Card>
      </div>

      <Card className="mt-6 bg-cobalt/5 border-cobalt/20">
        <div className="flex items-start gap-3">
          <Sparkles className="h-5 w-5 shrink-0 text-cobalt" />
          <div><p className="font-semibold text-ink">Personalised funding matches</p>
            <p className="mt-1 text-sm text-slatey">Based on your profile, you may be eligible for a Postgraduate Loan plus a means-tested bursary. Figures are estimates and subject to provider and funder confirmation.</p></div>
        </div>
      </Card>

      <div className="mt-6 flex gap-2">
        {TABS.map((t) => (
          <button key={t} onClick={() => setTab(t)} data-testid={`funding-tab-${t.toLowerCase()}`}
            className={`rounded-full px-4 py-2 text-sm font-semibold ${tab === t ? "bg-white border border-slate-200 text-ink shadow-sm" : "text-slatey"}`}>{t}</button>
        ))}
      </div>

      <div className="mt-4 space-y-3">
        {list.map((f) => (
          <Card key={f.slug} data-testid={`funding-${f.slug}`} className="flex items-center gap-4 py-5">
            <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-cobalt/10 text-cobalt"><Wallet className="h-5 w-5" /></span>
            <div className="min-w-0 flex-1">
              <p className="font-display font-bold text-ink truncate">{f.name}</p>
              <p className="text-sm text-slatey truncate">{f.provider} · {f.category}</p>
              <p className="text-sm font-semibold text-cobalt">{f.amount}</p>
            </div>
            <StatusBadge status={f.status} />
            <ChevronRight className="h-5 w-5 text-slate-300" />
          </Card>
        ))}
      </div>
    </div>
  );
}
